import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserFolderPage from './pages/UserFolderPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/folder" element={<UserFolderPage />} />
      </Routes>
    </Router>
  );
}

export default App;
